import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Text } from '@/components/typography';
import React from 'react';
import { ContactForm } from '../career/ContactForm';
export function Contact() {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["career"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("form.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-4 lg:mb-6" variant="inverted" anchorKey="form.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("form.text");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text variant="p2" className="text-light-gray-100 text-center">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mx-auto mt-12 max-w-192 lg:mt-16"><ContactForm /></div>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t4) {
    t6 = <div className="relative z-10 px-4">{t2}{t4}{t5}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}